import React, { FunctionComponent } from 'react';
import { fmtPrice } from '@upstart/harmony/lib/formatter';

interface Props {
  cashPayment?: number;
}

const CashPaymentRow: FunctionComponent<Props> = ({ cashPayment }) => (
  <div className="payment-row">{fmtPrice(cashPayment || 0)}</div>
);

export default CashPaymentRow;
